/* src/app/components/change-venue-popover/change-venue-popover.component.scss */
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 10px;
  background: white;
  margin: 0;
  overflow: hidden;
}
.title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
}
.info {
  font-family: AppFont, sans-serif;
  font-size: 12px;
  margin: 5px 0px 10px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
}
.button {
  height: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 26px;
  text-transform: uppercase;
  font-family: AppFont !important;
  max-width: 150px;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button:hover {
  background: #f2dbd9;
}
.button_main {
  background: #EBDFDA;
  font-size: var(--buttons-font-size);
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
}
.button_close {
  background: transparent;
  background: #EBDFDA;
  font-size: 14px;
  min-height: 25px;
  text-align: center;
  margin: 0;
  text-transform: var(--buttons-text-transform);
  color: var(--color-black);
}
/*# sourceMappingURL=change-venue-popover.component.css.map */
